// Item 408 — may this person see the Suspicious level? The profile in the auth store says: the server answers
// `suspicious_beta` (they can see a camera with the Beta switch on), and a superuser always can. Not known yet (a login
// from before this feature, the profile still on its way) = off, so the tab never shows and then goes away.
import { useAuthStore } from '@/store/authStore'

export function useSuspiciousBeta(): boolean {
  const user = useAuthStore((s) => s.user)
  return user?.is_superuser === true || user?.suspicious_beta === true
}
